import AccountDepositInterestSettings from "@/models/Accounts/DepositAccounts/Settings/AccountDepositInterestSettings";
import InterestRateType from "@/models/Products/InterestRateType";
import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import InterestDaysInYear from "@/models/Products/InterestDaysInYear";
import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import PeriodType from "@/models/Shared/PeriodType";
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import DayOfWeek from "@/models/Shared/DayOfWeek";
import Month from "@/models/Shared/Month";
import Amount from "@/models/Shared/Amount";
import BaseUpdateAccountSettings from "@/models/Accounts/Shared/BaseUpdateAccountSettings";

export default class UpdateAccountDepositInterestSettingsRequest extends BaseUpdateAccountSettings {
    enabled: boolean = false;
    interestBearingThreshold: Amount = new Amount();
    accruedPeriodType: PeriodType = PeriodType.Day;
    accruedPeriodValue: number = 1;
    accruedPeriodOnDayOfWeek: DayOfWeek = undefined;
    accruedPeriodOnDayOfMonth: number = undefined;
    accruedPeriodOnMonth: Month = undefined;
    calculatedOnBalanceType: InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType.AverageDailyBalance;
    daysInYearType: InterestDaysInYear = InterestDaysInYear.Actual365;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
    postedPeriodOnDayOfWeek: DayOfWeek = undefined;
    postedPeriodOnDayOfMonth: number = undefined;
    postedPeriodOnMonth: Month = undefined;
    postedPeriodType: PeriodType = PeriodType.Month;
    postedPeriodValue: number = 1;
    postingScheduleType: PostingScheduleType = undefined;
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    rateSourceId: string;

    public constructor(settings: AccountDepositInterestSettings, updatedAt: Date) {
        super(updatedAt);
        this.enabled = settings.enabled;
        this.interestBearingThreshold = settings.interestBearingThreshold;
        this.accruedPeriodOnDayOfWeek = settings.accruedPeriodOnDayOfWeek;
        this.accruedPeriodOnDayOfMonth = settings.accruedPeriodOnDayOfMonth;
        this.accruedPeriodOnMonth = settings.accruedPeriodOnMonth;
        this.accruedPeriodType = settings.accruedPeriodType;
        this.accruedPeriodValue = settings.accruedPeriodValue;
        this.accruedPeriodValue = +this.accruedPeriodValue
        this.calculatedOnBalanceType = settings.calculatedOnBalanceType;
        this.daysInYearType = settings.daysInYearType;
        this.nonWorkingDaysType = settings.nonWorkingDaysType;
        this.postedPeriodOnDayOfWeek = settings.postedPeriodOnDayOfWeek;
        this.postedPeriodOnDayOfMonth = settings.postedPeriodOnDayOfMonth;
        this.postedPeriodOnMonth = settings.postedPeriodOnMonth;
        this.postedPeriodType = settings.postedPeriodType;
        this.postedPeriodValue = settings.postedPeriodValue;
        this.postedPeriodValue = +this.postedPeriodValue;
        this.postingScheduleType = settings.postingScheduleType;
        this.rateType = settings.rateType;
        this.rateValue = settings.rateValue;
        this.rateValue = +this.rateValue;
        this.rateSourceId = settings.rateSourceId;
    }
}